import { render, staticRenderFns } from "./ProfileCreate.vue?vue&type=template&id=10971911&"
import script from "./ProfileCreate.vue?vue&type=script&lang=js&"
export * from "./ProfileCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports